package com.narbase.letsgo.web.views.admin.contactUs

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.weightOf
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.dimen
import com.narbase.kunafa.core.dimensions.percent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.drawable.Color
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.scrollable.scrollable
import com.narbase.letsgo.web.utils.table.headerCell
import com.narbase.letsgo.web.utils.table.listTable
import com.narbase.letsgo.web.utils.table.tableCell
import com.narbase.letsgo.web.utils.table.tableRow
import com.narbase.letsgo.web.utils.uploaders.fixOldBaseUrl
import com.narbase.letsgo.web.utils.verticalSeparator
import com.narbase.letsgo.web.utils.views.*

class ContactUsManagementComponent : Component() {

    private val viewModel = ContactUsManagementViewModel()

    private var listTableBody: View? = null

    private val upsertContactDialog = UpsertContactDialog {
        viewModel.getConfig()
    }

    override fun onViewMounted(lifecycleOwner: LifecycleOwner) {
        super.onViewMounted(lifecycleOwner)
        viewModel.getConfig()
    }

    private fun onListLoaded() {
        listTableBody?.clearAllChildren()
        listTableBody?.apply {
            viewModel.data?.contacts?.forEachIndexed { index, item ->
                tableRow {
                    style {
                        alignItems = Alignment.Center
                        paddingEnd = 8.px
                    }
                    tableCell({ weightOf(1) }) {
                        item.imageUrl?.let {
                            imageView {
                                style {
                                    width = 32.px
                                    height = 32.px
                                    borderRadius = 50.percent
                                    border = theme.standardBorder
                                }
                                element.src = it.fixOldBaseUrl()
                            }
                        } ?: textView { text = "-" }

                    }
                    tableCell(item.name, 1, 14.px)
                    tableCell(item.address, 1, 14.px)
                    tableCell(item.link ?: "-", 1, 14.px)
                    deleteIcon {
                        item.id?.let {
                            showRemoteDeleteConfirmationDialog(
                                message = "Are you sure you want to delete this item?".localized(),
                                uiState = viewModel.upsertUiState,
                                action = { viewModel.deleteItem(it) },
                                onDeleted = { viewModel.getConfig() }
                            )
                        }
                    }
                    onClick = {
                        upsertContactDialog.edit(item)
                    }
                }

                if (index != viewModel.data?.contacts?.lastIndex) {
                    verticalSeparator()
                }
            }
        }
    }

    override fun View?.getView() = view {
        id = "contactManagementRootView"
        style {
            matchParentDimensions
        }
        scrollable {
            style {
                matchParentDimensions
            }

            verticalLayout {
                style {
                    width = matchParent
                    height = wrapContent
                    padding = 32.px
                }

                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    textView {
                        text = "Contact Us Management".localized()
                        style {
                            width = wrapContent
                            fontSize = 20.px
                            fontWeight = "bold"
                        }
                    }

                    horizontalFiller()

                    addContactButton()

                }

                verticalLayout {
                    matchParentDimensions()
                    withLoadingAndError(viewModel.getConfigUiState,
                        onRetryClicked = { viewModel.getConfig() },
                        onLoaded = { onListLoaded() })

                    listTableBody = listTable {
                        headerCell("Icon".localized(), 1)
                        headerCell("Title".localized(), 1)
                        headerCell("Subtitle / Address / Phone".localized(), 1)
                        headerCell("External Link".localized(), 1)
                        headerCell("".localized(), { 24.px })
                    }
                }
            }
        }
    }

    private fun LinearLayout.addContactButton() {
        textView {
            style {
                color = Color.white
                padding = "2px 12px".dimen()
                backgroundColor = AppColors.mainColor
                borderRadius = 12.px
                pointerCursor()
                hover {
                    backgroundColor = AppColors.mainDarkColor
                }
            }

            onClick = {
                upsertContactDialog.add()
            }

            id = "AddContactButton"
            text = "+ Add new contact".localized()
        }
    }
}
